import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import FloatInput from "components/Input/FloatInput";
import {
  CustomSelect,
} from "components/Input/Index.js";
import uuid from "react-uuid";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { putPoint } from "services/ConfigServices";
import styled from "styled-components";
import { dico } from "variables/lists/dico";
import { charttext } from "variables/chart";
import { grouptypechartdata } from "variables/lists/charts";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import { agregategdatarealestate } from "variables/lists/charts";
import IntInput from "components/Input/IntInput";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const ChangeLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  margin: 1rem 0rem 0rem 0rem;
`;

function AdvancedDefDialogRealestate(props) {
  const { closeModal, def, formulapretty, formulaprettyEdited, serie } = props;

  const [replacebyzero, setReplacebyzero] = useState(def?.replacebyzero === 'true' || false);
  const [searchingroups, setSearchingroups] = useState(def?.searchingroups === 'true' || false);
  const [searchedgroup, setSearchedgroup] = useState(def?.searchedgroup || "site");
  const [agregatv, setAgregatv] = useState(def?.agregatv || "SUM");


  const handleSearchingroupsChange = (event) => {
    setSearchingroups(!searchingroups);
  };
  const handleSearchedgroupChange = (event) => {
    setSearchedgroup(event.target.value);
  };
  const handleAgregatevChange = (event) => {
    setAgregatv(event.target.value);
  };

  const handleReplacebyzeroChange = (event) => {
    setReplacebyzero(!replacebyzero);
  };

  const classes = useStyles();

  const handleSubmit = (event) => {
    let newformulapretty = JSON.parse(JSON.stringify(formulapretty));
    let obj = newformulapretty.find((o) => o.id === def.id);
    let index = newformulapretty.findIndex((o) => o.id === def.id);
    if (obj) {
      let newobj = { ...obj };
      newobj.replacebyzero = replacebyzero;
      newobj.searchingroups = searchingroups;
      if (searchingroups) {
        newobj.agregatv = agregatv;
        newobj.searchedgroup = searchedgroup;
      }
      newformulapretty[index] = newobj;
      formulaprettyEdited(newformulapretty, serie);
    }
    closeModal();
  };


  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <ChangeLabel>{charttext.replacebyzero}</ChangeLabel>
              </GridItem>
              <GridItem xs={3} sm={3} md={3} lg={3}>
                <div>
                  <CustomSwitch
                    style={{ marginLeft: "0.5rem" }}
                    inputTitle={''}
                    checkedState={replacebyzero}
                    handleSwitchChange={handleReplacebyzeroChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <ChangeLabel>{charttext.searchingroups}</ChangeLabel>
              </GridItem>
              <GridItem xs={3} sm={3} md={3} lg={3}>
                <div>
                  <CustomSwitch
                    style={{ marginLeft: "0.5rem" }}
                    inputTitle={''}
                    checkedState={searchingroups}
                    handleSwitchChange={handleSearchingroupsChange}
                  />
                </div>
              </GridItem>
              {
                searchingroups ?
                  <>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div>
                        <CustomSelect
                          inputTitle={charttext.searchedgroup}
                          selectValue={searchedgroup}
                          handleSelectValueChange={handleSearchedgroupChange}
                          data={grouptypechartdata}
                        />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div>
                        <CustomSelect
                          inputTitle={charttext.agregatv}
                          selectValue={agregatv}
                          handleSelectValueChange={handleAgregatevChange}
                          data={agregategdatarealestate}
                        />
                      </div>
                    </GridItem>
                  </> : <></>
              }



            </GridContainer>
          </GridItem>
        </GridContainer>
        <Button
          className={classes.submitButton}
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>

    </>
  );
}

export default AdvancedDefDialogRealestate;
